import axios from 'axios';
import React from 'react'
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import './Auth.css';
import { Link, useHistory } from "react-router-dom";

export default function Signup() {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
      } = useForm();
      const history = useHistory();

    const onSubmit = (data) => {
        axios.post(
          `https://ahlehaqserver.herokuapp.com/api/auth/signup`,
          data
        )
        .then(res => {
          if(res.data.message === 'success') {
              toast('Sign up success')
              history.push('/admin/login')
            }
        })
    };
    return (
        <div className="container">
            <div className="row mt-5 justify-content-center">
                <div className="col-md-5 mt-5">
                    <div className="authCardStyle">
                        <h3 className="text-center">Sign up</h3>
                        <form action="" onSubmit={handleSubmit(onSubmit)}>
                            <label htmlFor="" className="font-weight-bold mt-2">
                            Write your name
                            </label>
                            <input
                            type="text"
                            name="name"
                            placeholder="Write your name"
                            className="form-control rounded-pill"
                            {...register("name", { required: true })}
                            />
                            {errors.name && (
                            <span className=" text-muted text-center d-block">
                                This field is required
                            </span>
                            )}
                            <label htmlFor="" className="font-weight-bold mt-2">
                            Write your Email
                            </label>
                            <input
                            type="email"
                            name="email"
                            placeholder="Write your email address"
                            className="form-control rounded-pill"
                            {...register("email", { required: true })}

                            />
                         {errors.email && (
                            <span className=" text-light text-muted d-block">
                                This field is required
                            </span>
                            )}

                            <label htmlFor="" className="font-weight-bold mt-2">
                            Create a password
                            </label>
                            <input
                            type="password"
                            name="password"
                            placeholder="Write your password"
                            className="form-control rounded-pill"
                            {...register("password", { required: true })}
                            />
                            {errors.password && (
                            <span className=" text-light text-muted d-block">
                                This field is required
                            </span>
                            )}
                            <Link to="/admin/login">
                                <p className="text-muted text-center mb-3">Already have an account? Let's Login.</p>
                            </Link>
                            <div className="text-center mt-4">
                            <button type="submit" className="btn btn-info btn-block rounded-pill">
                                Sign Up
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
